import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Col, Container, Form, Image, InputGroup, Row, Spinner } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import FollowButton from './FollowButton';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import Masonry from "react-masonry-css";
import { FaHatCowboy } from 'react-icons/fa';
import Tile from './common/Tile';
import Thumb from './common/Thumb';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { arrayShuffle, mousedragscrollable } from '../service/CommonUtil';
import { Chip } from '@mui/material';

const Odai = () => {
    async function getImageListByTag1Month(ym,page){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/tag1Month/",{ym:ym,page:page}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getMessage(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/info").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ナビ
    const navigate = useNavigate()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // パラメータ
    let param = useParams()
    let paramYm = param.ym

    const [userSetting, setUserSetting] = useState([]);
    const [messageList,setMessageList] = useState([])
    const [ym,setYm] = useState()
    const [year,setYear] = useState(new Date().getFullYear())
    const [month,setMonth] = useState(new Date().getMonth())
    const [odaiList,setOdaiList] = useState([])
    const [loading,setLoading] = useState(true)

    useEffect(() => {
        // メッセージ取得
        getMessage().then(r=>{
            if(r.result){
                setMessageList(r.data)
            }
        })
        // タイトル設定
        document.querySelector("title").textContent = t("category.odai") + " | アワートAI - AIイラスト無料生成&投稿SNS"

        // お題
        let date = new Date()
        let month = date.getMonth() + 1
        month = (month < 10 ? "0" + month : month)
        let tempYm = paramYm
        if(paramYm === undefined){
            tempYm = date.getFullYear() + "-" + month
        }
        console.log(tempYm)
        let s = tempYm.split("-")
        setYm(tempYm)
        setYear(s[0])
        setMonth(parseInt(s[1]))
    },[])

    useEffect(() => {
        if(ym !== undefined){
            getImageListByTag1Month(ym,1).then(r => {
                if(r.result){
                    console.log(1)
                    setOdaiList(r.data.reverse().map(r => {
                        r.list = arrayShuffle(r.list)
                        return r
                    }))
                    console.log(2)
                    setLoading(false)
                    mousedragscrollable('.mousewrap')
                }
            })
        }
    },[ym])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const downloadOdaiList = () => {
        const content = odaiList.reverse().map(data => `${data.d}: ${data.odai}`).join('\n');
        const blob = new Blob([content], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${year}-${month.toString().padStart(2, '0')}_odai_list.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const week = [t("common.sun"),t("common.mon"),t("common.tue"),t("common.wed"),t("common.thu"),t("common.fri"),t("common.sat")]
    function getDayColor(day){
        if(day === 0){
            // 日曜
            return "#FF0000"
        } else if(day === 6) {
            // 土曜
            return "#0000FF"
        } else {
            return "inherit"
        }
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <Container className='mt-3 mb-3' style={{fontSize:"24px",fontWeight:"bold",borderLeft:"10px solid lightblue"}}>
            {t("category.odai")}
        </Container>
        <Container className='text-center'>
            <h2>{year}/{month}</h2>
            <Button variant='outline-secondary' onClick={() => {
                setLoading(true)
                let s = ym.split("-")
                let newYear = s[0]
                let newMonth = s[1]
                let newMonthStr = ""
                if(s[1] === "01"){
                    newYear = parseInt(s[0]) - 1
                    newMonth = 12
                    
                } else {
                    newMonth = parseInt(s[1]) - 1
                }
                newMonthStr = (newMonth > 9 ? newMonth : "0" + newMonth)
                setYm(newYear+"-"+newMonthStr)
                setYear(newYear)
                setMonth(parseInt(newMonth))
                navigate("/odai/"+newYear+"-"+newMonthStr)
            }} disabled={loading}>{t("common.prev")}</Button>
            &nbsp;
            <Button variant='outline-secondary' onClick={() => {
                setLoading(true)
                let s = ym.split("-")
                let newYear = s[0]
                let newMonth = s[1]
                let newMonthStr = ""
                if(s[1] === "12"){
                    newYear = parseInt(s[0]) + 1
                    newMonth = 1
                } else {
                    newMonth = parseInt(s[1]) + 1
                }
                newMonthStr = (newMonth > 9 ? newMonth : "0" + newMonth)
                setYm(newYear+"-"+newMonthStr)
                setYear(newYear)
                setMonth(parseInt(newMonth))
                navigate("/odai/"+newYear+"-"+newMonthStr)
            }} disabled={loading}>{t("common.next")}</Button>
            <br />
            {loading ? <Spinner animation="border" size="lg" className='mt-3' /> : ""}
        </Container>
        <Container className='mt-3 mb-3'>
            <Button variant='outline-primary' onClick={downloadOdaiList} disabled={odaiList.length === 0}>
                お題一覧をダウンロード
            </Button>
        </Container>
        <Container className='mt-3 mb-3'>
        {odaiList && odaiList.length > 0 && odaiList.map((data,i)=>{
            return <LinkContainer to={"/tag/"+data.odai+"/1"} key={i}>
            <Chip label={parseInt(data.d) + " #" + data.odai} variant={""} className='m-1' style={{fontSize:"12px",fontWeight:"bold"}} />
            </LinkContainer>
        })}
        </Container>
        <Container className='p-0'>
        {odaiList && odaiList.length > 0 && odaiList.map((data,i)=>{
            let tempDate = new Date()
            tempDate.setFullYear(year,month-1,data.d)
            let nowDate = new Date()

            if(tempDate.getFullYear() === nowDate.getFullYear()
                && tempDate.getMonth() === nowDate.getMonth()
                && tempDate.getDate() > nowDate.getDate()){
                    return ""
            }
            return <Container className='p-0 mb-3' key={i}>
                <Container className='d-flex justify-content-between' style={{fontSize:"24px",fontWeight:"bold",borderLeft:"10px solid lightblue",borderBottom:"3px solid lightblue"}}>
                    <div>
                        <span  style={{color:getDayColor(tempDate.getDay())}}>
                            {parseInt(data.d)}({week[tempDate.getDay()]})
                        </span>
                        <span className='p-1'>{data.odai}</span>
                    </div>
                    <LinkContainer to={"/tag/"+data.odai+"/1"}><Button variant='outline-secondary' style={{fontSize:"18px"}} className="mb-1">{t("common.more")}</Button></LinkContainer>
                </Container>
                <Container className='mt-3 d-flex p-0 swipe mousewrap' style={{overflow:"auto"}}>
                    {data.list.map((img,j) => {
                        return <Thumb data={img} i={j} dialog={dialog} key={j} list={data.list} listName={t(("category.odai"))} />
                    })} 
                </Container>
            </Container>
        })}

        </Container>

        <Footer />
    </div>
    )
}

export default Odai;
